export enum ReviewStatusEnum {
  ACCEPTED = "ACCEPTED",
  FLAGGED = "FLAGGED"
}
